<template>
  <div class="page">
    <div class="content">
      <router-view />
    </div>
    <nut-tabbar class="bottom_tabbar" :tabbar-list="tabList"
                :bottom="true">
    </nut-tabbar>
  </div>
</template>
<script>
export default {
  name: 'mainLayout',
  components: {},
  data() {
    const that = this
    return {
      tabList: [
        {
          'tabTitle': '首页',
          'curr': that.$route.path === '/index',
          'icon': require('@/assets/images/homeone@2x.png'),
          'activeIcon': require('@/assets/images/hometwo@2x.png'),
          'href': '#/index'
        },
        {
          'tabTitle': '商品分类',
          'curr': that.$route.path === '/mallCategory',
          'icon': require('@/assets/images/classification@2x.png'),
          'activeIcon': require('@/assets/images/ficationtwo@2x.png'),
          'href': '#/mallCategory'
        },
        {
          'tabTitle': '货源市场',
          'curr': that.$route.path === '/market',
          'icon': require('@/assets/images/marketone@2x.png'),
          'activeIcon': require('@/assets/images/markettwo@2x.png'),
          'href': '#/market'
        },
        {
          'tabTitle': '进货单',
          'curr': that.$route.path === '/purchase',
          'icon': require('@/assets/images/entryone@2x.png'),
          'activeIcon': require('@/assets/images/entrytwo@2x.png'),
          'href': '#/purchase'
        },
        {
          'tabTitle': '个人中心',
          'curr': that.$route.path === '/mine',
          'icon': require('@/assets/images/myone@2x.png'),
          'activeIcon': require('@/assets/images/mytwo@2x.png'),
          'href': '#/mine'
        }
      ]
    }
  },
  methods: {}
}
</script>
<style scoped>
.content {
  margin-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue